module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Form entries":"Formulareinträge","Conversations":"Konversationen"}}')
  delete Component.options._Ctor
}
